import React, { useEffect } from 'react';
import { FixedWithContainer } from '../../../common/CardBoardStyled';
import ReusableInfo from '@/presentation/reusables/Info';
import Button from '@/presentation/reusables/Button';
import Spinner from '@/presentation/components/Spinner';
import FailedPaymentModal from '../../components/FailedPaymentModal';
import Processing from '@/presentation/components/Processing';
import { TotalDebt } from '../../components/TotalDebt';
import { DivisionLine } from '@/presentation/modules/courses/modules/myCourses/components/MyCoursesCollapsibles/styled';
import { PayItemsByPeriod } from '../../components/PayItemsByPeriod';
import {
  EmptyPayments,
  HighlightedText,
  ItemsDescription,
  ItemsSection
} from '../../components/styled';
import EmptyIcon from '../../../../../assets/icons/events/noevents.svg';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import PaymentContainer from '../../components/ContainerPayments';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';
import Modal from '../../../procedures/components/Modal/Modal';

interface BalanceProps {
  goBackButton: () => void;
  goToPaymentHistory: () => void;
  items: IPaymentItem[];
  paysSelected: string[];
  currentPay: number;
  handleCheckboxChange: (_: string, b: number) => void;
  isLoadingPending: boolean;
  isLoadingBenefit: boolean;
  createOrder: () => void;
  totalPay: number;
  isLoadingCreateOrder: boolean;
  errorMessage: string[];
  setErrorMessage: React.Dispatch<React.SetStateAction<string[]>>;
  periodsPending: string[];
  restriction: boolean;
  setRestriction: (show: boolean) => void;
}

interface IPaymentItem {
  status: string;
  name: string;
  amount: string;
  recharge?: string;
  dueDate: number;
  itemsIds?: string[];
  periodDesc?: string;
  itemNumber: string;
  amountWithBenefits?: string;
  amountToPay: string;
  hasDiscountProntoPago?: boolean;
  paymentType: {
    id: string;
    desc: string;
  };
  billName?: string;
  discountProntoPago?: number;
  discountCicloCompleto?: number;
  discountBene?: number;
  dateCreate?: number;
  billingDate?: number;
}

const PayOnlineView = (props: BalanceProps) => {
  const {
    goBackButton,
    goToPaymentHistory,
    items,
    paysSelected,
    currentPay,
    handleCheckboxChange,
    isLoadingPending,
    isLoadingBenefit,
    createOrder,
    totalPay,
    isLoadingCreateOrder,
    errorMessage,
    setErrorMessage,
    periodsPending,
    restriction,
    setRestriction
  } = props;
  // set to false to prevent footer display
  const updatedItems = items.map((item) => ({
    ...item,
    isFullCycleDiscount: false
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `UTP + Portal | Pagos | Pago en Línea`;
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);

  const isLoading = isLoadingPending || isLoadingBenefit;
  const hasPendingItems = items.length > 0;

  return (
    <PaymentContainer>
      {isLoadingCreateOrder && <Processing isOpen={isLoadingCreateOrder} />}
      {/* <div
        style={{ margin: '0 auto 16px auto', maxWidth: '744px', width: '100%' }}
      /> */}
      <FixedWithContainer>
        <div className="payments">
          <SubsectionHeader title="Pago en línea" onClick={goBackButton} />
          {isLoading && <Spinner />}
          {!isLoading &&
            (hasPendingItems ? (
              <div>
                <ReusableInfo
                  backgroundColor="#fabd00"
                  iconColor="#161D1F"
                  style={{ marginTop: '8px', marginBottom: '24px' }}
                  fullParser
                  text={`
                  <div style="text-align: left">
                  <p>Toma en cuenta lo siguiente: </p>
                  <ul style="list-style: disc;margin-left: 22px;">
                  <li>Sin comisiones.</li>
                  <li>Solo tarjetas de crédito.</li>
                  <li>No aplica descuentos.</li>
                  <li>No permite pagos con tarjetas de BBVA, BCP,  Interbank y Scotiabank.</li>
                  </ul></div>`}
                />
                <ItemsSection>
                  <ItemsDescription>
                    <p>
                      <HighlightedText>
                        Selecciona el monto a pagar
                      </HighlightedText>
                    </p>
                    <p>
                      Empieza por el más antiguo según la fecha de vencimiento.
                    </p>
                  </ItemsDescription>

                  <div>
                    <DivisionLine backgroundColor="var(--card-focus)" />
                    {periodsPending?.map((period: string) => (
                      <PayItemsByPeriod
                        key={period}
                        paymentsArray={updatedItems}
                        period={period}
                        isPasarela
                        currentPay={currentPay}
                        paysSelected={paysSelected}
                        handleCheckboxChange={handleCheckboxChange}
                      />
                    ))}
                  </div>

                  <TotalDebt
                    totalPendingAmount={totalPay.toFixed(2)}
                    description="Total a pagar:"
                  />

                  <Button
                    data-test-id="button-pay"
                    text={`Confirmar S/. ${totalPay.toFixed(2)}`}
                    disabled={paysSelected.length === 0}
                    onClick={() => createOrder()}
                  />
                </ItemsSection>
              </div>
            ) : (
              <EmptyPayments online>
                <div className="emptyInfo">
                  <img src={EmptyIcon} alt="" />
                  <div>
                    <p>Sin pagos pendientes. ¡Estás al día!</p>
                    <p style={{ color: '#4F6168' }}>
                      Revisa el detalle de tus pagos realizados
                    </p>
                  </div>
                </div>
                <Button text="Ir a historial" onClick={goToPaymentHistory} />
              </EmptyPayments>
            ))}
        </div>

        {errorMessage && (
          <FailedPaymentModal
            handlerClose={() => setErrorMessage([''])}
            message={errorMessage?.[0]}
            title={errorMessage?.[1]}
            handlerReopen={() => createOrder()}
          />
        )}
      </FixedWithContainer>
      <Modal show={restriction} handleClose={() => setRestriction(false)}>
        <PopPupRestriction handleClick={() => setRestriction(false)} />
      </Modal>
    </PaymentContainer>
  );
};

export default PayOnlineView;
